export const getConfig = () => {
    let baseUrl = '';
    let appId = '';
    let creatorWebsiteUrl = '';
    let ecWebsiteUrl = '';
    const currentUrl = window.location.href;
    if (currentUrl.includes('localhost')) {
        baseUrl = "http://localhost:8080"
        appId = "OYKLEOTMGQVGEFUC0LQI"
        creatorWebsiteUrl = "http://localhost:4200/"
        ecWebsiteUrl = "http://localhost:8081/"
    } else if (currentUrl.includes('development.oyecreators.com')) {
        baseUrl = "https://development-api.oyecreators.com"
        appId = "OYKLEOTMGQVGEFUC0LQI"
        creatorWebsiteUrl = "https://development-app.oyecreators.com/"
        ecWebsiteUrl = "https://ec-dev.oyecreators.com/"
    } else if (currentUrl.includes('staging.oyecreators.com')) {
        baseUrl = "https://staging-api.oyecreators.com"
        appId = "OYKLEOTMGQVGEFUC0LQI"
        creatorWebsiteUrl = "https://staging-app.oyecreators.com/"
        ecWebsiteUrl = "https://ec-staging.oyecreators.com/"
    } else {
        baseUrl = "https://api.oyecreators.com"
        appId = "TEEFHOAFD8CGNFXK5IH2"
        creatorWebsiteUrl = "https://app.oyecreators.com/"
        ecWebsiteUrl = "https://ec.oyecreators.com/"
    }
    return { baseUrl, appId, creatorWebsiteUrl, ecWebsiteUrl }
}
